"use client";
import { createContext } from "react";
import { createGatheringStore } from "./gatheringStore";

export type GatheringContextType = {
	store: ReturnType<typeof createGatheringStore>;
};

export const GatheringContext = createContext<GatheringContextType | null>(null);
